import { render, staticRenderFns } from "./email-stage-template-list.vue?vue&type=template&id=6644d52e&"
import script from "./email-stage-template-list.vue?vue&type=script&lang=js&"
export * from "./email-stage-template-list.vue?vue&type=script&lang=js&"
import style0 from "./email-stage-template-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports